export var TypeActionPlayerProfilePicture;
(function (TypeActionPlayerProfilePicture) {
    TypeActionPlayerProfilePicture["Set"] = "ActionPlayerProfilePicture > Set";
})(TypeActionPlayerProfilePicture || (TypeActionPlayerProfilePicture = {}));
export var actionPlayerProfilePictureSet = function (profilePictureId) { return ({
    profilePictureId: profilePictureId,
    type: TypeActionPlayerProfilePicture.Set,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/profile-picture/actionPlayerProfilePicture.ts
// module id = 855
// module chunks = 3